// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3GE13","clinicsSelect":"TableHeading_clinicsSelect__Ga8qU"};